import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
	{  //登录页面
		path: '/',
		name: 'login',
		component:()=>import('@/page/login/login')
	},
	{  //登录页面
		path: '/videos',
		name: 'videos',
		component:()=>import('@/page/videos/index'),
	},
	{  //主界面
		path: '/index',
		name: 'index',
		meta:{title:"首页"},
		component:()=>import('@/page/index/index'),
		redirect:'/dashboard',
		children:[
			{
				//控制台
				path: '/dashboard',
				name: 'dashboard',
				meta:{title:"控制台"},
				component:()=>import('@/page/index/dashboard'),
			},
			{
				//店铺管理
				path: '/store',
				name: 'store',
				meta:{title:"店铺管理"},
				children:[
					{
						//管理员管理
						path: '/store-lists',
						name: 'store-lists',
						meta:{title:"门店列表"},
						component:()=>import('@/page/store/index'),
					},
					{
						//服务管理
						path: '/store-services',
						name: 'store-services',
						meta:{title:"服务管理"},
						component:()=>import('@/page/store/services'),
					},
					{
						//视频设备管理
						path: '/store-camera',
						name: 'store-camera',
						meta:{title:"摄像头管理"},
						component:()=>import('@/page/store/camera'),
					}
				]
				
			},
			{
				//Mqtt管理
				path: '/mqtt',
				name: 'mqtt',
				meta:{title:"Mqtt管理"},
				component:()=>import('@/page/mqtt/index'),
			},
			{
				//权限管理
				path: '/auth',
				name: 'auth',
				meta:{title:"权限管理"},
				redirect:'/auth-admin',
				children:[
					{
						//管理员管理
						path: '/auth-admin',
						name: 'auth-admin',
						meta:{title:"管理员管理"},
						component:()=>import('@/page/auth/index'),
					},
					{
						//角色管理
						path: '/auth-role',
						name: 'auth-role',
						meta:{title:"角色管理"},
						component:()=>import('@/page/auth/role'),
					},
					{
						//功能管理
						path: '/auth-node',
						name: 'auth-node',
						meta:{title:"功能管理"},
						component:()=>import('@/page/auth/node'),
					}
				]
			},
			{
				//日志管理
				path: '/log',
				name: 'log',
				meta:{title:"日志管理"},
				redirect:'/log-store',
				children:[
					{
						//店铺日志管理
						path: '/log-store',
						name: 'log-store',
						meta:{title:"店铺日志管理"},
						component:()=>import('@/page/log/store'),
					},
					{
						//客服日志管理
						path: '/log-kefu',
						name: 'log-kefu',
						meta:{title:"客服日志管理"},
						component:()=>import('@/page/log/kefu'),
					},
					{
						//推流日志管理
						path: '/log-plug-flow',
						name: 'log-plug-flow',
						meta:{title:"推流日志管理"},
						component:()=>import('@/page/log/plug_flow'),
					},
					{
						//操作日志管理
						path: '/log-handle',
						name: 'log-handle',
						meta:{title:"操作日志管理"},
						component:()=>import('@/page/log/handle'),
					}
				]
			},
			{
				//渠道管理
				path: '/channel',
				name: 'channel',
				meta:{title:"渠道管理"},
				component:()=>import('@/page/channel/index'),
			},
			{
				//系统设置
				path: '/setting',
				name: 'setting',
				meta:{title:"系统设置"},
				component:()=>import('@/page/setting/index'),
			},
			{
				//工作台
				path: '/worktable',
				name: 'worktable',
				meta:{title:"工作台"},
				component:()=>import('@/page/worktable/index'),
			}
		]
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

export default router
